import { TableTextCell } from '../TableTextCell'

import { formatPropertyShare } from './TablePropertyShareCell.utils'

function TablePropertyShareCell({ value, ...cellProps }) {
  return <TableTextCell {...cellProps} value={formatPropertyShare(value)} />
}

export default TablePropertyShareCell
